<section class="skills section" id="skills">
  <h2 class="section__title">Skills</h2>
  <span class="section__subtitle">My technical level</span>

  <div class="skills__container container grid">
    <div>
      <!-- Skills 1-->
      <div class="skills__content" [ngClass]="{'skills__open': frontend === true, 'skills__close': frontend === false}">
        <div class="skills__header" (click)="onClickSkillFrontend()">
          <i class="uil uil-brackets-curly skills__icon"></i>

          <div>
            <h1 class="skills__titles">Frontend developer</h1>
            <span class="skills__subtitle">More than 2 years</span>
          </div>

          <i class="uil uil-angle-down skills__arrow"></i>
        </div>

        <div class="skills__list grid">
          <div class="skills__data">
            <div class="skills__titles">
              <h3 class="skills__name">HTML</h3>
              <span class="skills__number">95%</span>
            </div>
            <div class="skills__bar">
              <span class="skills__percentage skills__html"></span>
            </div>
          </div>

          <div class="skills__data">
            <div class="skills__titles">
              <h3 class="skills__name">CSS</h3>
              <span class="skills__number">90%</span>
            </div>
            <div class="skills__bar">
              <span class="skills__percentage skills__css"></span>
            </div>
          </div>

          <div class="skills__data">
            <div class="skills__titles">
              <h3 class="skills__name">SCSS</h3>
              <span class="skills__number">80%</span>
            </div>
            <div class="skills__bar">
              <span class="skills__percentage skills__scss"></span>
            </div>
          </div>

          <div class="skills__data">
            <div class="skills__titles">
              <h3 class="skills__name">JavaScript</h3>
              <span class="skills__number">65%</span>
            </div>
            <div class="skills__bar">
              <span class="skills__percentage skills__javascript"></span>
            </div>
          </div>

          <div class="skills__data">
            <div class="skills__titles">
              <h3 class="skills__name">Angular</h3>
              <span class="skills__number">85%</span>
            </div>
            <div class="skills__bar">
              <span class="skills__percentage skills__angular"></span>
            </div>
          </div>
        </div>
      </div>

      <!-- Skills 2 -->
      <div class="skills__content" [ngClass]="{'skills__open': backend === true, 'skills__close': backend === false}">
        <div class="skills__header" (click)="onClickSkillBackend()">
          <i class="uil uil-server-network skills__icon"></i>

          <div>
            <h1 class="skills__titles">Backend developer</h1>
            <span class="skills__subtitle">More than a year</span>
          </div>

          <i class="uil uil-angle-down skills__arrow"></i>
        </div>

        <div class="skills__list grid">
          <div class="skills__data">
            <div class="skills__titles">
              <h3 class="skills__name">PHP</h3>
              <span class="skills__number">40%</span>
            </div>
            <div class="skills__bar">
              <span class="skills__percentage skills__php"></span>
            </div>
          </div>

          <div class="skills__data">
            <div class="skills__titles">
              <h3 class="skills__name">Firebase</h3>
              <span class="skills__number">90%</span>
            </div>
            <div class="skills__bar">
              <span class="skills__percentage skills__firebase"></span>
            </div>
          </div>

          <div class="skills__data">
            <div class="skills__titles">
              <h3 class="skills__name">Node Js</h3>
              <span class="skills__number">60%</span>
            </div>
            <div class="skills__bar">
              <span class="skills__percentage skills__node"></span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <!-- Skills 3 -->
      <div class="skills__content" [ngClass]="{'skills__open': designer === true, 'skills__close': designer === false}">
        <div class="skills__header" (click)="onClickSkillDesigner()">
          <i class="uil uil-swatchbook skills__icon"></i>
          <div>
            <h1 class="skills__titles">Designer</h1>
            <span class="skills__subtitle">less than a year</span>
          </div>
          <i class="uil uil-angle-down skills__arrow"></i>
        </div>

        <div class="skills__list grid">
          <div class="skills__data">
            <div class="skills__titles">
              <h3 class="skills__name">Figma</h3>
              <span class="skills__number">50%</span>
            </div>
            <div class="skills__bar">
              <span class="skills__percentage skills__figma"></span>
            </div>
          </div>

          <div class="skills__data">
            <div class="skills__titles">
              <h3 class="skills__name">Sketch</h3>
              <span class="skills__number">40%</span>
            </div>
            <div class="skills__bar">
              <span class="skills__percentage skills__sketch"></span>
            </div>
          </div>

          <div class="skills__data">
            <div class="skills__titles">
              <h3 class="skills__name">Photoshop</h3>
              <span class="skills__number">60%</span>
            </div>
            <div class="skills__bar">
              <span class="skills__percentage skills__photoshop"></span>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</section>
